import DataStore from '@/engine/stores/data-store';

class TemplatesDataStore extends DataStore {
}

export default new TemplatesDataStore();
